import { render, staticRenderFns } from "./WorkshopGroupListModal.vue?vue&type=template&id=e8ef3654&"
import script from "./WorkshopGroupListModal.vue?vue&type=script&lang=js&"
export * from "./WorkshopGroupListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports